import React, { Component } from 'react';
import { lazyImport, LazyComponent } from '../LazyImportComponent';

const getLightBox = lazyImport(
    () => import('@zocdoc/components/src/Lightbox'),
    'Lightbox'
);

export default class InsuranceCardLightBox extends Component {
    render() {
        const {
            images,
            showInsuranceCardLightBox,
            trackSwitchImageInPreview,
            closeImagePreview,
        } = this.props;

        if (showInsuranceCardLightBox && images.length > 0) {
            const LightBox = getLightBox();
            return (
                <LazyComponent
                    componentName="Lightbox"
                    onFailure={closeImagePreview}
                >
                    <LightBox
                        data-test="light-box"
                        images={images}
                        onChangeImage={trackSwitchImageInPreview}
                        onClickCancel={closeImagePreview}
                    />
                </LazyComponent>
            );
        } else {
            return <span data-test="light-box-hidden" />;
        }
    }
}
